<template>
    <div class="layer">
        <div class="wrap">
            <div class="error_content">
                <div class="error_logo">
                    <img src="@/assets/largeLogo.png" alt="" />
                </div>
                <div class="error_title">
                    <h1>403</h1>
                    <h3>접근이 거부되었습니다.</h3>
                </div>
                <div class="error_text">
                    <div>
                        <p>요청하신 페이지 접근이 거부되었습니다.</p>
                        <p>입력하신 페이지의 주소가 정확한지 다시 한번 확인해주시기 바랍니다.</p>
                    </div>
                </div>
                <div class="error_btn" @click="router.back()">
                    <button>뒤로 가기</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import router from "@/router";

    export default {
        setup() {
            return {
                router,
            };
        },
    };
</script>
